import React from 'react';
import { findByText } from 'Common/Utils';
import { IntroNotice } from './IntroNotice';
import { HookShotChaperone, ClickGesture } from 'Snippets/Redundancy';

export const AliasedRegistry = [
	{
		message: <IntroNotice />,
		find: 'a[data-chaperone-trigger]',
	},
	{
		message: (
			<>
				It is inevitable that some form fields are multiple with the same name
				on it. The problem is we wanted to add those new or other fields into
				form state registry. for that reason <b>formydable</b> use{' '}
				<b>alias registry</b> and make a counter measure about those stuffs.
			</>
		),
		find(target) {
			return findByText(target, 'span:InputMultiple')[0];
		},
	},
	{
		message: (
			<>
				To implement multiple input text field. You have to make a component
				that handle the adding and removing of field...
			</>
		),
		find(target) {
			return findByText(target, 'span:fields')[0];
		},
	},
	{
		message: (
			<>
				Firstly, We have to register our component <b>props</b> to make a
				default first text field in our collection of fields...
			</>
		),
		find(target) {
			return findByText(target, 'span:props')[1];
		},
	},
	{
		message: (
			<>
				All the fields that are going to be add, are sharing with the same
				properties except the <b>alias</b>...
			</>
		),
		find(target) {
			return findByText(target, 'span:alias')[0];
		},
	},
	{
		message: (
			<>
				Since all our fields sharing the same name or properties. The alias will
				be the key to keep the distinction of each field in the schema....
			</>
		),
		find(target) {
			return findByText(target, 'span:unique')[0];
		},
	},
	{
		message: (
			<>
				To render all collection of field that all have been registered in the{' '}
				<b>fields</b>. We have to use <b>map</b>...
			</>
		),
		find(target) {
			return findByText(target, 'span:map')[0];
		},
	},
	{
		message: (
			<>
				Now, We will go to our button label. If index is equal to <b>0</b>. It
				will be a adding button...
			</>
		),
		find(target) {
			return findByText(target, 'span:btnLabel')[0];
		},
	},
	{
		message: (
			<>
				When we are adding a field data from collection. We just spread the{' '}
				<b>props</b> and assign a alias to make it unique as identifier...
			</>
		),
		find(target) {
			return findByText(target, 'span:props')[4];
		},
	},
	{
		message: (
			<>
				When we are removing field data from collection. We will use{' '}
				<b>alias</b> to identify which field will be remove...
			</>
		),
		find(target) {
			return findByText(target, 'span:field')[4];
		},
	},
	{
		message: <>Now, lets take a look on our map render...</>,
		find(target) {
			return findByText(target, 'span:return')[2];
		},
	},
	{
		message: (
			<>
				Since we are inside <b>map</b> we have to put <b>key</b> property on
				each wrapper. We are going to use <b>alias</b> since it is our
				identifier...
			</>
		),
		find(target) {
			return findByText(target, 'span:key')[0];
		},
	},
	{
		message: (
			<>
				Now, we are going to our field component(InputWithAliasRules) which
				handle the registration and changes of each field to the schema. We will
				get into that shortly...
			</>
		),
		find(target) {
			return findByText(target, 'span:InputWithAliasRules')[0];
		},
		...HookShotChaperone({
			target: (target) => findByText(target, 'span:InputWithAliasRules')[0],
			from: (target) => findByText(target, 'span:InputWithAliasRules')[1],
			to: (target) => findByText(target, 'span:InputWithAliasRules')[0],
		}),
	},
	{
		message: <>Then, We will spread-assign all property of each field...</>,
		find(target) {
			return findByText(target, 'span:field')[6];
		},
	},
	{
		message: (
			<>
				Now, When we go to our field component(InputWithAliasRules). We have the
				access to all properties...
			</>
		),
		find(target) {
			return findByText(target, 'span:type')[0];
		},
	},
	{
		message: (
			<>
				Then, We get the <b>FormSupplier</b> value by using{' '}
				<b>useFormSupplier</b>...
			</>
		),
		find(target) {
			return findByText(target, 'span:useFormSupplier')[1];
		},
	},
	{
		message: (
			<>
				Now, to register with alias. All we just have to do is to put{' '}
				<b>alias</b> in the registry...
			</>
		),
		find(target) {
			return findByText(target, 'span:formRegistry')[1];
		},
	},
	{
		message: (
			<>Now, I will show you how we update our schema with alias registry...</>
		),
		find(target) {
			return findByText(target, 'span:formUpdate')[1];
		},
	},
	{
		message: (
			<>
				Before, we just directly put <b>formUpdate</b> on every onChange.
				because <b>formUpdate</b> depends solely on the input attribute{' '}
				<b>name</b> to know which field state to update. But now, we have to
				access the second parameter, to directly tell <b>formUpdate</b>{' '}
				which field state will be updated, and will not depend on the input
				attribute <b>name</b>. since we register the alias which will be the key
				to access it's state...
			</>
		),
		find(target) {
			return findByText(target, 'span:handleFieldChange')[0];
		},
		...HookShotChaperone({
			target: (target) => findByText(target, 'span:handleFieldChange')[0],
			from: (target) => findByText(target, 'span:handleFieldChange')[1],
			to: (target) => findByText(target, 'span:handleFieldChange')[0],
		}),
	},
	{
		message: (
			<>
				Finally, We will use our component inside our container (
				<b>FormWrapper</b>). The one we created in <b>Advance Design Pattern</b>{' '}
				section...
			</>
		),
		find(target) {
			return findByText(target, 'span:InputMultiple')[1];
		},
	},
	{
		message: <>And That's all! Let's try out the result!</>,
		find: 'input',
		isDoneOnClick: true,
		gesture: <ClickGesture />,
		background: {
			backdropStyle: { opacity: 1 },
			highlightStyle: { backgroundColor: 'rgba(255,255,255, 1)' },
		},
	},
];
